import { BiRightArrowCircle } from "react-icons/bi"
import Button from "../Button/Button"

const Schedule = (props) => {
    const { heading, heading2, bold, bold2 } = props

    return (
        <>
            <div className='schedule_inner_div'>
                <div className='solution_list_text_div3'>
                    <h4> {heading} </h4>
                    <b> {bold} </b>
                </div>
                <div className='solution_list_text_div5'>
                    <h4>{heading2}</h4>
                    <b>{bold2}</b>
                </div>
                <div className="schedule_btn_div">
                    <Button title="SCHEDULE FREE CALL" icon={<BiRightArrowCircle size={18} />} />
                </div>
            </div>
        </>
    )
}
export default Schedule